var getTextInputTheme = theme => ({
  colors: {
    border: {
      initial: theme.colors.greys[20],
      focus: theme.colors.ultraViolets[70],
      error: theme.colors.reds[50]
    },
    text: {
      initial: theme.colors.greys[100],
      disabled: theme.colors.greys[50]
    },
    placeholder: {
      initial: theme.colors.greys[50]
    },
    background: {
      initial: theme.colors.inputBackground,
      hover: theme.colors.white,
      disabled: theme.colors.greys[10]
    }
  }
});
export { getTextInputTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dElucHV0LmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9
